import { SortOrder } from '@price-for-profit/micro-services';
import { useQuery } from 'react-query';
import { DRAFT_NAME_CHANGE_DOCUMENT_TYPE } from 'shared/constants';
import { useService } from 'shared/providers';
import { GetDraftNameChangesResponse } from 'shared/services';
import { SortableDraftNameChangeFields } from 'shared/types';
export interface GetDraftNameChangeProps {
  page?: number;
  pageSize?: number;
  sortOrder?: SortOrder;
  sortBy?: SortableDraftNameChangeFields;
}

export function useQueryDraftNameChange(props: GetDraftNameChangeProps) {
  const { draftNameChangeService } = useService();
  const { data, isLoading, isFetching } = useQuery<GetDraftNameChangesResponse, Error>(
    [DRAFT_NAME_CHANGE_DOCUMENT_TYPE, props],
    () =>
      draftNameChangeService.getDraftNameChanges({
        page: props.page,
        pageSize: props.pageSize,
        sortOrder: props.sortOrder,
        sortBy: props.sortBy,
      })
  );

  return { nameChanges: data, isLoading, isFetching } as const;
}
